import styled from 'styled-components';

import { media } from '@/utils/mediaQueries';

export const ImagePreviewWrapper = styled.div`
  position: relative;
  width: 250px;
  height: 250px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};

  &:hover {
    border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#d1d5db')};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

export const ImageThumbnail = styled.div<{ $imageUrl: string }>`
  width: 100%;
  height: 100%;
  background-image: url('${({ $imageUrl }) => $imageUrl}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const DeleteOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;

  ${ImagePreviewWrapper}:hover & {
    opacity: 1;
  }

  /* Dotyk (brak hover): przycisk widoczny, bez przyciemniania zdjęcia. */
  ${media.touch} {
    opacity: 1;
    background: transparent;
  }
`;

export const DeleteButton = styled.button`
  background: #ef4444;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 300;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #dc2626;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.98);
  }
`;
